"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.relayWithCallWithSyncFeeERC2771 = void 0;
const utils_1 = require("../../../utils");
const types_1 = require("../../types");
const types_2 = require("../types");
const index_js_1 = require("../getSignatureDataERC2771/index.js");
const safeTransformStruct_js_1 = require("../utils/safeTransformStruct.js");
const relayWithCallWithSyncFeeERC2771 = (payload, config) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const { request, client, options, sponsorApiKey } = payload;
        if (request.isConcurrent) {
            const isConcurrent = true;
            const { isRelayContext, feeToken } = request;
            const type = types_2.ERC2771Type.ConcurrentCallWithSyncFee;
            const { struct, signature } = yield (0, index_js_1.getSignatureDataERC2771)({ request, client, type }, config);
            return yield (0, utils_1.post)({
                relayCall: types_1.RelayCall.CallWithSyncFeeERC2771,
                request: Object.assign(Object.assign({}, (0, safeTransformStruct_js_1.safeTransformStruct)(struct)), { feeToken, isRelayContext: isRelayContext !== null && isRelayContext !== void 0 ? isRelayContext : true, userSignature: signature, isConcurrent,
                    sponsorApiKey, gasLimit: (options === null || options === void 0 ? void 0 : options.gasLimit)
                        ? options.gasLimit.toString()
                        : undefined, retries: options === null || options === void 0 ? void 0 : options.retries }),
            }, config);
        }
        else {
            const isConcurrent = false;
            const { isRelayContext, feeToken } = request;
            const type = types_2.ERC2771Type.CallWithSyncFee;
            const { struct, signature } = yield (0, index_js_1.getSignatureDataERC2771)({ request, client, type }, config);
            return yield (0, utils_1.post)({
                relayCall: types_1.RelayCall.CallWithSyncFeeERC2771,
                request: Object.assign(Object.assign({}, (0, safeTransformStruct_js_1.safeTransformStruct)(struct)), { feeToken, isRelayContext: isRelayContext !== null && isRelayContext !== void 0 ? isRelayContext : true, userSignature: signature, isConcurrent,
                    sponsorApiKey, gasLimit: (options === null || options === void 0 ? void 0 : options.gasLimit)
                        ? options.gasLimit.toString()
                        : undefined, retries: options === null || options === void 0 ? void 0 : options.retries }),
            }, config);
        }
    }
    catch (error) {
        const errorMessage = error.message;
        throw new Error(`GelatoRelaySDK/callWithSyncFeeERC2771: Failed with error: ${errorMessage}`);
    }
});
exports.relayWithCallWithSyncFeeERC2771 = relayWithCallWithSyncFeeERC2771;
